export default __webpack_public_path__ + "static/media/Group9225.07275e09.svg";